import React, { useState } from 'react'
import {
    Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,
    IconButton, TextField, Tooltip, Typography,
} from '@material-ui/core'
import ChatIcon from '@material-ui/icons/Chat'
import SmsIcon from '@material-ui/icons/Sms'
import SendIcon from '@material-ui/icons/Send'
import { useRecoilValue } from 'recoil'
import { userInfoState } from '../../recoil/atoms'
import api from '../../api/client'

/**
 * دو دکمهٔ کوچک برای هر ردیف فهرست:
 *   💬 پیام درون‌سامانه (به /messages?to=<userId> می‌رود و مخاطب انتخاب می‌شود)
 *   ✉️ پیامکِ موردی (دیالوگ با شمارهٔ همان شخص)
 *
 * props: userId · mobile · name · size
 */
const RowActions = ({ userId, mobile, name, size = 'small' }) => {
    const userInfo = useRecoilValue(userInfoState)
    const canSms = !!userInfo && userInfo.role === 'Admin'
    const [open, setOpen] = useState(false)
    const [text, setText] = useState('')
    const [to, setTo] = useState(mobile ? String(mobile) : '')
    const [busy, setBusy] = useState(false)
    const [result, setResult] = useState(null)

    const openMsg = (e) => {
        e.stopPropagation()
        if (!userId) return
        window.location.href = `/messages?to=${userId}`
    }

    const openSms = (e) => {
        e.stopPropagation()
        setResult(null)
        setOpen(true)
    }

    const send = async () => {
        setBusy(true)
        setResult(null)
        try {
            const payload = text.trim()
                ? { text, mobile: to || undefined, user_id: userId || undefined }
                : null
            if (!payload) {
                setResult({ ok: false, msg: 'متن پیامک را بنویسید.' })
                setBusy(false)
                return
            }
            const r = await api.post('users/sms/send/', payload)
            setResult({
                ok: !!r.data.success,
                msg: r.data.success
                    ? `ارسال شد به ${r.data.to} (${r.data.parts} پیامک)`
                    : (r.data.message || 'ارسال ناموفق بود'),
            })
            if (r.data.success) setText('')
        } catch (e) {
            const msg = (e.response && e.response.data && e.response.data.detail) || 'ارسال ناموفق بود'
            setResult({ ok: false, msg })
        } finally {
            setBusy(false)
        }
    }

    const parts = Math.max(1, Math.ceil((text.length || 0) / 70))

    return (
        <Box display="flex" alignItems="center" style={{ gap: 2 }}>
            <Tooltip title="ارسال پیام درون‌سامانه">
                <span>
                    <IconButton size={size} onClick={openMsg} disabled={!userId}>
                        <ChatIcon fontSize="small" style={{ color: '#1a237e' }} />
                    </IconButton>
                </span>
            </Tooltip>
            {canSms && (
                <Tooltip title={mobile ? 'ارسال پیامک' : 'شمارهٔ موبایل ثبت نشده'}>
                    <span>
                        <IconButton size={size} onClick={openSms} disabled={!mobile}>
                            <SmsIcon fontSize="small" style={{ color: mobile ? '#00695c' : '#c3c8d8' }} />
                        </IconButton>
                    </span>
                </Tooltip>
            )}

            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth dir="rtl">
                <DialogTitle style={{ fontWeight: 800 }}>
                    ارسال پیامک {name ? `به ${name}` : ''}
                </DialogTitle>
                <DialogContent dividers>
                    <TextField
                        fullWidth size="small" variant="outlined" label="شمارهٔ موبایل"
                        value={to} onChange={(e) => setTo(e.target.value)}
                        inputProps={{ dir: 'ltr' }} style={{ marginBottom: 12 }}
                        disabled={!!mobile}
                        helperText={mobile ? 'شمارهٔ ثبت‌شدهٔ همین شخص' : 'شماره را وارد کنید'}
                    />
                    <TextField
                        fullWidth multiline rows={4} variant="outlined" label="متن پیامک"
                        value={text} onChange={(e) => setText(e.target.value)}
                        helperText={`${text.length} کاراکتر — ${parts} پیامک`}
                    />
                    {result && (
                        <Typography style={{
                            marginTop: 10, fontSize: 13, fontWeight: 700,
                            color: result.ok ? '#2e7d32' : '#c62828',
                        }}>
                            {result.msg}
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>بستن</Button>
                    <Button
                        variant="contained" color="primary" startIcon={<SendIcon />}
                        onClick={send} disabled={busy || !text.trim()}
                        style={{ fontWeight: 700 }}
                    >
                        {busy ? 'در حال ارسال…' : 'ارسال پیامک'}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default RowActions
